import {UrlConstants} from '../shared/url.constant';
import {ConstantUtils} from './constant.utils';
import {AdminService} from '../shared/admin.services';
import { readElementValue } from '@angular/core/src/render3/util';
export class CommonUtil {

  public static AADHAR_NO_FORMAT = '0000 0000 0000';
  public static ZIPCODE_FORMAT = '000000';
  public static TIME_FORMAT = '00:00 00';
  public static AMOUNT_PATTERN = '^\d{0,5}(\d\.\d?|\.\d)?\d?$';

  private static _MIN_DATE = {year: 2019, month: 1, day: 1};
  private static _MAX_DATE = {year: 2020, month: 1, day: 1};


  public static DATE_CONFIG: any = {
    dateInputFormat: 'DD-MM-YYYY',
    containerClass: 'theme-default',
    todayHighlight: true,
  };

  constructor(private adminService: AdminService) {
    if (!localStorage[ConstantUtils.BOOTSTRAP]) {
      this.loadBootstrap();
    }
  }

  public static capitalizeAt0(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  public static capitalize(s) {
    return s.toUpperCase();
  }

  public static numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  public static alphaNumericOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    return((charCode > 64 && charCode < 91) || (charCode > 96 && charCode < 123) || charCode == 8 || charCode == 32 || (charCode >= 48 && charCode <= 57));
  }

  public static formatName(obj) {
    obj.first_name = (obj.first_name && obj.first_name.length > 0 && obj.first_name !== '-Nil-' )
      ? obj.first_name : '';
    obj.last_name = (obj.last_name && obj.last_name.length > 0 && obj.last_name !== '-Nil-' )
      ? obj.last_name : '';
    obj.formatted_name = (obj.first_name || '') + ' ' + (obj.last_name || '');
    obj.formatted_name = (obj.formatted_name).trim() || '';
    obj.first_name = (obj.formatted_name).trim() || '';
    obj.last_name = '';

    obj.father_first_name = (obj.father_first_name && obj.father_first_name.length > 0 && obj.father_first_name !== '-Nil-' )
      ? obj.father_first_name : '';
    obj.father_last_name = (obj.father_last_name && obj.father_last_name.length > 0 && obj.father_last_name !== '-Nil-' )
      ? obj.father_last_name : '';
    obj.formatted_father_name = (obj.father_first_name || '') + ' ' + (obj.father_last_name || '');
    obj.formatted_father_name = (obj.formatted_father_name).trim() || '';
    obj.father_first_name = (obj.formatted_father_name).trim() || '';
    obj.father_last_name = '';

    obj.mother_first_name = (obj.mother_first_name && obj.mother_first_name.length > 0 && obj.mother_first_name !== '-Nil-' )
      ? obj.mother_first_name : '';
    obj.mother_last_name = (obj.mother_last_name && obj.mother_last_name.length > 0 && obj.mother_last_name !== '-Nil-' )
      ? obj.mother_last_name : '';
    obj.formatted_mother_name = (obj.mother_first_name || '') + ' ' + (obj.mother_last_name || '');
    obj.formatted_mother_name = (obj.formatted_mother_name).trim() || '';
    obj.mother_first_name = (obj.formatted_mother_name).trim() || '';
    obj.mother_last_name = '';

    return obj;
  }

  public static formatAddress(obj) {
    obj.door_no = (obj.door_no && obj.door_no.length > 0 && obj.door_no !== '-Nil-' )
      ? obj.door_no : '';
    obj.street = (obj.street && obj.street.length > 0 && obj.street !== '-Nil-' )
      ? obj.street : '';
    obj.area = (obj.area && obj.area.length > 0 && obj.area !== '-Nil-' )
      ? obj.area : '';
    obj.formatted_address = (obj.door_no || '') + ' '
      + (obj.street || '') + ' '
      + (obj.area || '');
    obj.formatted_address = (obj.formatted_address).trim() || '';
    obj.door_no = (obj.formatted_address).trim() || '';
    obj.street = '';
    obj.area = '';
    return obj;
  }

  public static getCurrentAcademicYear() {
    if (localStorage[ConstantUtils.BOOTSTRAP]) {
      const bootstrapData = JSON.parse(localStorage[ConstantUtils.BOOTSTRAP]);
      const startYear = bootstrapData.academic_year.start_year ? bootstrapData.academic_year.start_year + ' - ' : '';
      const endYear = bootstrapData.academic_year.end_year ? bootstrapData.academic_year.end_year : '';
      if (startYear !== '' && endYear !== '') {
        return startYear + endYear;
      } else {
        return 'Academic Year Not Defined';
      }
    }
  }

  public static getStartAcademicYear() {
    if (localStorage[ConstantUtils.BOOTSTRAP]) {
      const bootstrapData = JSON.parse(localStorage[ConstantUtils.BOOTSTRAP]);
      const startYear = bootstrapData.academic_year.start_year ? bootstrapData.academic_year.start_year : 2019;
      return new Date(`${Number(startYear)}-01-01`);
    }
  }

  public static getEndAcademicYear() {
    if (localStorage[ConstantUtils.BOOTSTRAP]) {
      const bootstrapData = JSON.parse(localStorage[ConstantUtils.BOOTSTRAP]);
      const endYear = bootstrapData.academic_year.end_year ? bootstrapData.academic_year.end_year : 2020;
      return new Date(`${Number(endYear)}-12-31`);
    }
  }

  public static getBootstrapData() {
    if (localStorage[ConstantUtils.BOOTSTRAP]) {
      return JSON.parse(localStorage[ConstantUtils.BOOTSTRAP]);
    }
  }


  public static getSchoolCopyright() {
    if (localStorage[ConstantUtils.BOOTSTRAP]) {
      const bootstrapData = JSON.parse(localStorage[ConstantUtils.BOOTSTRAP]);
      const schoolName = bootstrapData.school.school_name ? bootstrapData.academic_year.end_year + ' ' + bootstrapData.school.school_name : '';
      if (schoolName !== '') {
        return schoolName;
      } else {
        return 'Thinkwise';
      }
    }
  }

  public static isObjectEmpty(card) {
    return Object.keys(card).length === 0;
  }

  public static formatDate(date) {
    if (/\d{2}-\d{2}-\d{4}/.test(date)) {
      return date;
    } else {
      let d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) {
        month = '0' + month;
      }
      if (day.length < 2) {
        day = '0' + day;
      }

      return [day, month, year].join('-');
    }
  }

  public static formatTime(time){
    const dateTime = new Date(time);

    const hours = dateTime.getUTCHours();
    const minutes = dateTime.getUTCMinutes();
    // const seconds = dateTime.getUTCSeconds();
    // const milliseconds = dateTime.getUTCMilliseconds();

    const amOrPm = hours >= 12 ? "PM" : "AM";
    const timeString = `${hours}:${minutes} ${amOrPm}`;

    return timeString;
  }
  public static removeEmptyArray(list) {
    const finalList = [];
    if (list !== null) {
      list.forEach(element => {
        if (element === '') {
          list.splice(list.indexOf(element), 1);
        } else {
          finalList.push(element);
        }
      });
      return finalList;
    }
  }

  public static bloodGroupList() {

    const list = [];
    list.push('O− ve');
    list.push('O+ ve');
    list.push('A− ve');
    list.push('A+ ve');
    list.push('B− ve');
    list.push('B+ ve');
    list.push('AB− ve');
    list.push('AB+ ve');

    return list;
  }

  public static enquiryClassList() {

    const list = [];
    list.push('PRE-KG');
    list.push('LKG');
    list.push('UKG');
    list.push('GRADE I');
    list.push('GRADE II');
    list.push('GRADE III');
    list.push('GRADE IV');
    list.push('GRADE V');
    list.push('GRADE VI');
    list.push('GRADE VII');
    list.push('GRADE VIII');
    list.push('GRADE IX');
    list.push('GRADE X');
    list.push('GRADE XI');
    list.push('GRADE XII');

    return list;
  }

  public static checkWindowUrl() {
    console.log('hostname ### ', window.location.hostname);
    console.log('href ### ', window.location.href);
    console.log('pathname ### ', window.location.pathname);
    console.log('origin ### ', window.location.origin);
    console.log('port ### ', window.location.port);

    const masterurl = 'http://thinkwise-admin-web-app-qa-master.preview.medicalconcierge.co.in/';
    const baseUrl = masterurl.split('.')[0];
    const domain = baseUrl.split('/');
    const env = domain[2].split('-')[4];
    console.log('MASTER ENV ## ', env);
  }

  public static ISOformatDate(date) {
    if (/\d{2}-\d{2}-\d{4}/.test(date)) {
      return date;
    } else {
      let d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) {
        month = '0' + month;
      }
      if (day.length < 2) {
        day = '0' + day;
      }

      return [year, month, day].join('-');
    }
  }

  public loadBootstrap() {
    this.adminService.getBootstrap({url: UrlConstants.bootstrap, params: ''}).then(res => {
      localStorage[ConstantUtils.BOOTSTRAP] = JSON.stringify(res.data);
      const bootstrapData = JSON.parse(localStorage[ConstantUtils.BOOTSTRAP]);
      const startYear = bootstrapData.academic_year.start_year ? bootstrapData.academic_year.start_year + ' - ' : '';
      const endYear = bootstrapData.academic_year.end_year ? bootstrapData.academic_year.end_year : '';
      if (startYear !== '' && endYear !== '') {

        const minDate = Number(startYear);
        const maxDate = Number(endYear);

        return startYear + endYear;
      } else {
        return 'Academic Year Not Defined';
      }
    }, (err) => {
    });
  }

  // get getMinDate(): { month: number; year: number; day: number } {
  //   return this._MIN_DATE;
  // }
  //
  // set setMinDate(value: { month: number; year: number; day: number }) {
  //   this._MIN_DATE = value;
  // }
  //
  // get getMaxDate(): { month: number; year: number; day: number } {
  //   return this._MAX_DATE;
  // }
  //
  // set setMaxDate(value: { month: number; year: number; day: number }) {
  //   this._MAX_DATE = value;
  // }

  // List used for naming purpose in receipt
  public static specialFeeRecurringList(recurringPeriod) {
    const recurringListData =  [{ name: 'Months', value: 30 }, { name: 'Quarters', value: 90 },
    { name: 'Half-Years', value: 180 }, { name: 'Years', value: 365 }]
    let data = recurringListData.find(item=> item.value === recurringPeriod)
    return data.name
  }

  public static sortStudentsByGender(studentsArr,sortBy){
    const bootstrapData = JSON.parse(localStorage.getItem(ConstantUtils.BOOTSTRAP));
    bootstrapData.student_sort_order = sortBy; //change the student sort order in bootstrap
    const updatedBootstrapData = JSON.stringify(bootstrapData);
    localStorage.setItem(ConstantUtils.BOOTSTRAP,updatedBootstrapData)

    studentsArr.forEach((obj)=> this.formatStudentName(obj))
    let boysArr = [];
    let girlsArr = [];
    let others = [];
    studentsArr.forEach((student)=>{

      const gender = student.gender.toLowerCase();
      if(gender === ConstantUtils.male || gender === 'm'){
        boysArr.push(student)
      }else if (gender === ConstantUtils.female || gender === 'f'){
        girlsArr.push(student)
      }else{
        others.push(student)
      }
    })

    boysArr.sort((a, b) => a.student_full_name.localeCompare(b.student_full_name));
    girlsArr.sort((a, b) => a.student_full_name.localeCompare(b.student_full_name));
    others.sort((a, b) => a.student_full_name.localeCompare(b.student_full_name));

    if(sortBy === ConstantUtils.boys) {
      return boysArr.concat(girlsArr,others);
    }else if(sortBy === ConstantUtils.girls) {
      return girlsArr.concat(boysArr,others);
    }else{
      return studentsArr;
    }
  }

  public static sortStudentsOnLoad(studentsArr,sortBy){
    console.log("studentsArr",studentsArr)
    studentsArr.forEach((obj)=> this.formatStudentName(obj))
    let boysArr = [];
    let girlsArr = [];
    let others = [];
    studentsArr.forEach((student)=>{
      const gender = student.gender.toLowerCase();
      if(gender === ConstantUtils.male){
        boysArr.push(student)
      }else if (gender === ConstantUtils.female){
        girlsArr.push(student)
      }else{
        others.push(student)
      }
    })

    boysArr.sort((a, b) => a.student_full_name.localeCompare(b.student_full_name));
    girlsArr.sort((a, b) => a.student_full_name.localeCompare(b.student_full_name));
    others.sort((a, b) => a.student_full_name.localeCompare(b.student_full_name));

    if(sortBy === ConstantUtils.boys) {
      return boysArr.concat(girlsArr,others);
    }else if(sortBy === ConstantUtils.girls) {
      return girlsArr.concat(boysArr,others);
    }else{
      return studentsArr;
    }
  }

  public static formatStudentName(obj){
    obj.first_name = (obj.first_name && obj.first_name.length > 0 && obj.first_name !== '-Nil-' )
    ? obj.first_name : '';
  obj.last_name = (obj.last_name && obj.last_name.length > 0 && obj.last_name !== '-Nil-' )
    ? obj.last_name : '';
  obj.student_full_name = (obj.first_name || '') + ' ' + (obj.last_name || '');
  }

}
